import { UnstyledButton } from "@classdojo/web";
import { HeadlineText } from "@classdojo/web/nessie";
import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import { TranslatedString } from "@classdojo/web/pods/i18n/translate";
import React from "react";

type AppRemoteCardProps = React.PropsWithChildren<{
  onRequestHide?: VoidFunction;
  title?: TranslatedString;
  icon?: string;
  backgroundColor?: string;
  headerStyle?: ThemeUIStyleObject;
  headerIconStyle?: ThemeUIStyleObject;
  className?: string;
}>;

const AppRemoteCard = (props: AppRemoteCardProps) => {
  const { headerStyle: customHeaderStyle, headerIconStyle: customHeaderIconStyle, className } = props;

  return (
    <div
      sx={{
        border: "dt_card",
        borderRadius: "dt_radius_s",
        boxShadow: RAW_cssValue("0 8px 16px 0 rgba(0, 0, 0, 0.05)"),
        color: RAW_cssValue("#3e425d"),
      }}
      className={className}
    >
      <header sx={{ ...headerStyle, ...customHeaderStyle }}>
        {props.icon && (
          <div sx={{ ...headerIconStyle, ...customHeaderIconStyle }}>
            <div
              sx={{
                ...tileStyle,
                backgroundColor: RAW_cssValue(props.backgroundColor || "#c4c4c4"),
              }}
            >
              <img src={props.icon} sx={iconStyle} alt="" />
            </div>
          </div>
        )}
        <HeadlineText as="h1" textAlign="center" sx={titleStyle}>
          {props.title}
        </HeadlineText>
        {props.onRequestHide && (
          <UnstyledButton data-name="" sx={headerCloseButtonStyle} onClick={props.onRequestHide}>
            {"×"}
          </UnstyledButton>
        )}
      </header>
      {props.children}
    </div>
  );
};

const headerStyle: ThemeUIStyleObject = {
  display: "flex",
  position: "relative",
};

const headerIconStyle: ThemeUIStyleObject = {
  flex: "0 0 24px",
  margin: RAW_cssValue("24px"),
  position: "absolute",
  left: 0,
};

const headerCloseButtonStyle: ThemeUIStyleObject = {
  position: "absolute",
  right: "0",
  top: "0",
  paddingTop: "dt_s",
  paddingRight: "dt_l",
  fontSize: "40px",
  color: "dt_content_secondary",
};

const tileStyle: ThemeUIStyleObject = {
  display: "block",
  width: "24px",
  height: "24px",
  margin: RAW_cssValue("0 auto"),
  borderRadius: "dt_radius_s",
  lineHeight: "22px",
  textAlign: "center",
};

const iconStyle: ThemeUIStyleObject = {
  display: "inline-block",
  maxWidth: "14px",
  maxHeight: "14px",
  verticalAlign: "middle",
};

const titleStyle: ThemeUIStyleObject = {
  marginX: "auto",
  marginTop: "dt_l",
};

export default AppRemoteCard;
